import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';
import Loading from '../Loading/Loading';

export default function Dropzone(props) {
    const { onFileSelect, accept = '*/*', multiple = false, className, children, isBusy, busyContent } = props;

    const [isDragOver, setIsDragOver] = useState(false);
    const fileInputRef = useRef(null);

    const handleDragEnter = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragOver(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragOver(false);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragOver(false);

        const files = Array.from(e.dataTransfer.files);
        if (files.length > 0 && onFileSelect) {
            onFileSelect(multiple ? files : files[0]);
        }
    };

    const handleFileInputChange = (e) => {
        if (isBusy) return;

        const files = Array.from(e.target.files);
        if (files.length > 0 && onFileSelect) {
            onFileSelect(multiple ? files : files[0]);
        }
    };

    const handleClick = () => {
        if (isBusy) return;

        fileInputRef.current?.click();
    };

    return (
        <div
            className={cn(
                'relative border border-dashed rounded-lg p-6  transition-all duration-200 ease-in-out cursor-pointer',
                'border-gray-300 bg-gray-50 hover:bg-gray-100',
                'flex flex-col items-center justify-center',
                isDragOver && 'border-primary bg-primary/10 hover:bg-primary/10',
                isBusy && 'pointer-events-none',
                className,
            )}
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
            onClick={handleClick}
        >
            <input
                ref={fileInputRef}
                type="file"
                accept={accept}
                multiple={multiple}
                onChange={handleFileInputChange}
                className="hidden"
            />

            <div className="text-center pointer-events-none max-w-3xs text-sm text-balance">{children}</div>
            {isBusy && (
                <div className="absolute inset-0 flex flex-col gap-3 items-center justify-center bg-gray-50/90">
                    <Loading />
                    {busyContent && (
                        <div className="text-sm text-gray-500 text-center text-balance px-6">{busyContent}</div>
                    )}
                </div>
            )}
        </div>
    );
}

Dropzone.propTypes = {
    onFileSelect: PropTypes.func.isRequired,
    accept: PropTypes.string,
    multiple: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node,
    isBusy: PropTypes.bool,
    busyContent: PropTypes.node,
};
